import { render, staticRenderFns } from "./NewsInnerContent.vue?vue&type=template&id=03b2be42&"
import script from "./NewsInnerContent.vue?vue&type=script&lang=js&"
export * from "./NewsInnerContent.vue?vue&type=script&lang=js&"
import style0 from "./NewsInnerContent.vue?vue&type=style&index=0&id=03b2be42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports